var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import CustomInput from "../cms/Input";
export default {
    components: { CustomInput: CustomInput },
    props: {
        headers: {
            required: true
        },
        fields: {
            required: true
        },
        checkboxes: { type: Array },
        items: {
            required: true
        },
        addAction: { default: false },
        secondaryAction: { default: false },
        secondaryActionTitle: { default: 'Import' },
        updateAction: { default: false },
        removeAction: { default: false },
        additionalAction: { default: false },
        additionalActionRule: { type: Function },
        additionalActionTitle: { default: false },
        viewAction: { default: false },
        rowCriteria: { default: false },
        fieldCriteria: { default: false },
        searchFields: { default: false },
        showHeader: { default: true },
        showAsCard: { default: true },
        exportXls: { default: false },
        exportPdf: { default: false },
        title: { default: false },
        subTitle: { default: false },
        hideSearch: { default: false },
        sort: { default: '' },
        searchSort: { default: 'DESC' },
        size: {
            type: Number,
            required: false,
            default: 25
        },
        xhrPaginate: { default: false },
        xhrLoadEvent: { default: false }
    },

    data: function data() {
        var sortOrders = {};
        this.fields.forEach(function (key) {
            sortOrders[key] = 1;
        });
        return {
            selectedRow: false,
            sortKey: '',
            filterKey: '',
            searchText: '',
            sortOrder: 'DESC',
            sortOrders: sortOrders,
            pageNumber: 0,
            searchData: this.items,
            totalRecords: false,
            showSearch: false,
            loadingMore: false
        };
    },


    watch: {
        items: function items(newData, oldData) {
            this.searchData = newData;
            if (this.$el.offsetParent === null) {
                window.removeEventListener("scroll", this.scroll);
            }
        },
        searchText: function searchText(newVal, oldVal) {
            if (newVal == '') {
                Event.$emit(this.xhrLoadEvent);
            }
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.sortKey = this.sort;

        Event.$on('close-flyout', function () {
            _this.selectedRow = false;
        });

        Event.$on('close-full-modal', function () {
            _this.selectedRow = false;
        });

        Event.$on('close-small-modal', function () {
            _this.selectedRow = false;
        });

        Event.$on('data-table-loading', function () {
            _this.loadingMore = true;
        });

        Event.$on('data-table-loaded', function () {
            _this.loadingMore = false;

            if (_this.xhrPaginate && _this.isVisible()) {
                window.addEventListener("scroll", _this.scroll);
            }
        });

        Event.$on('data-table-count', function (count) {
            return _this.totalRecords = count;
        });

        this.$nextTick(function () {
            //this.loading = false
        });
    },

    methods: {
        isVisible: function isVisible() {
            return this.$el.offsetParent !== null;
        },
        xhrSearch: function xhrSearch() {
            this.filteredData = [];
            var isDate = this.searchText.length > 6 && (moment(this.searchText, 'YYYY-M-D', true).isValid() || moment(this.searchText, 'M/D/YYYY', true).isValid());
            Event.$emit(this.xhrLoadEvent, 0, this.searchText, null, this.searchSort, isDate);
        },
        clearSearch: function clearSearch() {
            this.filteredData = [];
            this.searchText = '';
            this.sortKey = '';
        },
        showSearchBox: function showSearchBox() {
            this.showSearch = !this.showSearch;
        },
        scroll: function scroll() {

            var scrollY = window.scrollY;
            var visible = document.documentElement.clientHeight;
            var pageHeight = document.documentElement.scrollHeight;
            var bottomOfPage = visible + scrollY >= pageHeight;
            var bottomOfWindow = bottomOfPage || pageHeight < visible;

            if (bottomOfWindow) {
                // load more records
                console.log('bottom of ' + this.title);
                this.nextPage();
            }
        },
        nextPage: function nextPage() {
            this.pageNumber++;
            if (this.xhrPaginate) {
                Event.$emit(this.xhrLoadEvent, this.pageNumber + 1, this.searchText, this.sortKey, this.sortOrder);
            }
        },
        prevPage: function prevPage() {
            this.pageNumber--;
        },
        add: function add() {
            Event.$emit(this.addAction);
        },
        secondary: function secondary() {
            Event.$emit(this.secondaryAction);
        },
        exportToExcel: function exportToExcel() {
            Event.$emit(this.exportXls);
        },
        exportToPdf: function exportToPdf() {
            Event.$emit(this.exportPdf);
        },
        view: function view(item, idx) {
            if (this.viewAction) {
                this.selectedRow = idx;
                Event.$emit(this.viewAction, item, idx);
            }
        },
        update: function update(item, idx) {
            Event.$emit(this.updateAction, item, idx);
        },
        remove: function remove(item, idx) {
            Event.$emit(this.removeAction, item, idx);
        },
        additionalMethod: function additionalMethod(item) {
            Event.$emit(this.additionalAction, item);
        },
        checkboxClicked: function checkboxClicked(item, field) {
            item[field] = !item[field];
            Event.$emit('update-checked-item', item);
        },
        sortBy: function sortBy(key) {

            this.filteredData = [];
            this.sortKey = key;
            this.sortOrder == 'ASC' ? this.sortOrder = 'DESC' : this.sortOrder = 'ASC';

            this.sortOrders[key] = this.sortOrders[key] * -1;

            if (this.xhrPaginate) {
                Event.$emit(this.xhrLoadEvent, this.pageNumber, this.searchText, this.sortKey, this.sortOrder);
            }
        },
        checkRowCriteria: function checkRowCriteria(item, idx) {
            if (this.rowCriteria) {
                var $criteria = this.rowCriteria;
                if ($criteria.value == item[$criteria.field]) {
                    return $criteria.class;
                }
            }
        },
        checkFieldCriteria: function checkFieldCriteria(item, idx) {
            if (this.fieldCriteria) {
                var $criteria = this.fieldCriteria;
                if ($criteria.value === item[$criteria.field]) {
                    return $criteria.class;
                }
            }
        },
        checkField: function checkField(item, idx, field, fieldIdx) {
            if (field != undefined && field.includes(".")) {
                var objs = field.split(".");

                if (item[objs[0]]) {
                    var child = JSON.parse(JSON.stringify(item[objs[0]]));
                    if (child != null) {
                        field = child[objs[1]];
                    } else {
                        field = '';
                    }
                } else {
                    field = '';
                }
            } else {
                field = item[field];
            }

            if (typeof this.headers[fieldIdx] != "string" && this.headers[fieldIdx].filter != undefined) {
                return Vue.filter(this.headers[fieldIdx].filter)(field);
            } else {
                return field;
            }
        },
        checkHeader: function checkHeader(header) {
            if (typeof header != "string") {
                return header.title;
            } else {
                return header;
            }
        }
    },

    computed: {
        pageCount: function pageCount() {
            var l = this.searchData.length + 1;
            if (this.totalRecords) {
                l = this.totalRecords;
            }

            var s = this.size;

            return Math.floor(l / s);
        },
        loading: function loading() {
            return this.filteredData.length < 1;
        },


        filteredData: {

            get: function get() {
                var $el = this;
                var sortKey = this.sortKey;
                var filterKey = this.filterKey && this.filterKey.toLowerCase();
                var order = this.sortOrders[sortKey] || 1;
                var data = this.items;

                var start = this.pageNumber * this.size;
                var end = start + this.size;

                if (!this.xhrPaginate) {

                    if (filterKey) {
                        data = data.filter(function (row) {
                            return Object.keys(row).some(function (key) {
                                return row[key] && _typeof(row[key]) == 'object' ? Object.keys(row[key]).some(function (key2) {
                                    if ($el.searchFields.length) {
                                        return $el.searchFields.includes(key2) && String(row[key][key2]) && String(row[key][key2]).toLowerCase().indexOf(filterKey) > -1;
                                        // return $el.searchFields.includes(key2) && String(row[key]).toLowerCase().indexOf(filterKey) > -1;
                                    } else {
                                        return String(row[key][key2]).toLowerCase().indexOf(filterKey) > -1;
                                    }
                                }) : $el.searchFields.length ? $el.searchFields.includes(key) && String(row[key]).toLowerCase().indexOf(filterKey) > -1 : String(row[key]).toLowerCase().indexOf(filterKey) > -1;
                            });
                        });
                        this.searchData = data;
                    }

                    if (sortKey) {
                        var prop = sortKey.split('.');
                        var len = prop.length;

                        data = data.slice().sort(function (a, b) {
                            var i = 0;
                            while (i < len) {

                                // These two checks are for when the object is missing from a record
                                if (a[prop[i]] === null) {
                                    a = '';
                                    break;
                                }

                                if (b[prop[i]] === null) {
                                    b = '';
                                    break;
                                }

                                a = a[prop[i]];
                                b = b[prop[i]];
                                i++;
                            }

                            //sort numerics like Unit Number
                            a = Number.parseInt(a) == a ? Number.parseInt(a) : a;
                            b = Number.parseInt(b) == b ? Number.parseInt(b) : b;

                            return (a === b ? 0 : a > b ? 1 : -1) * order;
                        });
                    }
                }

                return data;
            },

            set: function set(newValue) {
                var data = [];
            }

        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/layout/DataTable.vue
// module id = ynbK
// module chunks = 0 1